import { Col, Popover, Row } from 'antd';
import { gatewayApi } from 'api/gatewayApi';
import { useAppDispatch } from 'app/hooks';
import clsx from 'clsx';
import { GatewayInfo } from 'models/gateway';
import moment from 'moment';
import * as React from 'react';
import { gatewayActions } from '../GatewayInfo/gatewaySlice';
import style from './ItemGatewayList.module.scss';
export interface ItemGatewayListProps {
  item: GatewayInfo;
  setIsShowGatewayDetail: (value: boolean) => void;
}

export default function ItemGatewayList({ item, setIsShowGatewayDetail }: ItemGatewayListProps) {
  const [itemGateWay, setItemGateWay] = React.useState<GatewayInfo>(item);
  const dispatch = useAppDispatch();
  React.useEffect(() => {
    (async () => {
      try {
        const response: GatewayInfo = await gatewayApi.fetchGatewayInfo({
          type: 'gateway_id',
          id: item.id,
        });
        setItemGateWay({ ...itemGateWay, ...response });
      } catch (error) {
        console.log('Failed to fetch plant details', error);
      }
    })();
  }, []);

  return (
    <Row
      onClick={() => {
        dispatch(gatewayActions.fetchGatewayInfo(itemGateWay));
        setIsShowGatewayDetail(false);
      }}
      className={style.root}
    >
      <Col className={style.item_gateway_label} span={4}>
        <Popover content={itemGateWay.code}>{itemGateWay.code}</Popover>
      </Col>
      <Col className={style.item_gateway_label} span={8}>
        <Popover content={itemGateWay.label}>{itemGateWay.label}</Popover>
      </Col>
      <Col className={style.item_gateway} span={5} style={{ height: '30px' }}>
        <div
          className={clsx(style.status_gateway_item, {
            [style.active]: itemGateWay.active,
          })}
        >
          {itemGateWay.active ? 'active' : 'inactive'}
        </div>
      </Col>
      <Col className={style.item_gateway_label} span={7}>
        <Popover content={moment(itemGateWay.last_activity_time).format('YYYY-MM-DD HH:mm:ss')}>
          {moment(itemGateWay.last_activity_time).format('YYYY-MM-DD HH:mm:ss')}
        </Popover>
      </Col>
    </Row>
  );
}
